"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpClient = exports.handlePromiseLikeErrors = exports.getRpcServerUrl = void 0;
var json_rpc_2_0_1 = require("json-rpc-2.0");
var helpers_1 = require("../helpers");
var index_1 = require("../../index");
var getRpcServerUrl = function () {
    return "".concat(index_1.asperaSdk.globals.asperaAppUrl, ":").concat(index_1.asperaSdk.globals.rpcPort);
};
exports.getRpcServerUrl = getRpcServerUrl;
/**
 * Wraps a promise like object and returns a promise that supports catch.
 *
 * @param promise the HTTP promise like to wrap
 *
 * @returns promise for the HTTP connection with catch supporting error
 */
var handlePromiseLikeErrors = function (promise) {
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    promise.then(function (response) {
        promiseInfo.resolver(response);
    }, function (error) {
        promiseInfo.rejecter(error);
    });
    return promiseInfo.promise;
};
exports.handlePromiseLikeErrors = handlePromiseLikeErrors;
/**
 * JSON RPC client using HTTP (fetch) as transport.
 */
var JSONRPCHttpClient = /** @class */ (function () {
    function JSONRPCHttpClient() {
        var _this = this;
        /**
         * Request handler for the JSON-RPC client. This function is called by the JSON-RPC library
         * after forming the RPC request.
         *
         * @param request JSON-RPC request to send to the server
         */
        this.handleRequest = function (request) {
            var options = {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                },
                body: (0, helpers_1.safeJsonString)(request),
            };
            var rpcServerURL = (0, exports.getRpcServerUrl)();
            return fetch(rpcServerURL, options).then(function (response) {
                if (response.ok) {
                    return response.json().then(function (rpcResponse) { return _this.client.receive(rpcResponse); });
                }
                else if (request.id !== undefined) {
                    throw Promise.reject(response.statusText);
                }
            });
        };
        this.request = function (method, data) {
            return _this.client.request(method, data);
        };
        this.client = new json_rpc_2_0_1.JSONRPCClient(this.handleRequest);
    }
    return JSONRPCHttpClient;
}());
/**
 * Client used for making requests to Aspera.
 */
var HttpClient = /** @class */ (function () {
    function HttpClient() {
        var _this = this;
        this.request = function (method, payload) {
            if (payload === void 0) { payload = {}; }
            return (0, exports.handlePromiseLikeErrors)(_this.httpClient.request(method, payload));
        };
        this.httpClient = new JSONRPCHttpClient();
    }
    ;
    return HttpClient;
}());
exports.httpClient = new HttpClient();
exports.default = {
    httpClient: exports.httpClient,
    handlePromiseLikeErrors: exports.handlePromiseLikeErrors,
};
